"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var type_guards_1 = require("../../type-guards");
var message_file_image_1 = __importDefault(require("./message-file-image"));
var message_file_1 = __importDefault(require("./message-file"));
function MessageFiles(_a) {
    var message = _a.message;
    return (react_1.default.createElement(react_1.default.Fragment, null, message.files.map(function (file) {
        var mapKey = (0, type_guards_1.isDatabaseFile)(file)
            ? file.key
            : "temp-".concat(new Date().getTime(), "-").concat(file.name, "-").concat(file.size);
        return ((0, type_guards_1.isDatabaseFile)(file) && file.content_type.includes("image/")) ||
            (!(0, type_guards_1.isDatabaseFile)(file) && file.type.includes("image/")) ? (react_1.default.createElement(message_file_image_1.default, { file: file, key: mapKey })) : (react_1.default.createElement(message_file_1.default, { file: file, key: mapKey }));
    })));
}
exports.default = MessageFiles;
